import React, { useState, useEffect, useCallback, useMemo } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import AppConst from '../apis/appconst';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import Select from 'react-select';
import BalanceSheet from './BalanceSheet'; // ← NEW IMPORT (adjust path if needed)
import IpdNetCollection from './IpdNetCollection'; // ← NEW IMPORT

function Daybook() {
    // ========== TAB STATE ==========
    const [activeTab, setActiveTab] = useState('transactions'); // 'transactions' | 'balance' | 'ipd_net'
    const [balanceCount, setBalanceCount] = useState(0); // received from BalanceSheet child
    const [ipdNetCount, setIpdNetCount] = useState(0); // received from IpdNetCollection child
    const [fromTime, setFromTime] = useState('');
    const [toTime, setToTime] = useState('');
    // ========== ORIGINAL DAYBOOK STATE ==========
    const [transactions, setTransactions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [totals, setTotals] = useState({ cash: 0, card: 0, online: 0, total: 0 });
    const [departmentTotals, setDepartmentTotals] = useState({});

    const [expensesTotal, setExpensesTotal] = useState(0);
    const [netAmount, setNetAmount] = useState(0);
    
    const [collapsedGroups, setCollapsedGroups] = useState({});   // {} = all open
    const toggleGroup = (key) =>
        setCollapsedGroups(prev => ({ ...prev, [key]: !prev[key] }));

    const ldata = useMemo(() => { try { return JSON.parse(sessionStorage.getItem("ldata") || "{}"); } catch { return {}; } }, []);
const [branchMeta, setBranchMeta] = useState({ is_branch_user:false, is_admin:false, branches_exist:false, branches:[] });
const [selectedBranches, setSelectedBranches] = useState([]);
const branchFilterActive = selectedBranches.length > 0;
const branchOptions = useMemo(() => {
    const opts = (branchMeta.branches || []).map(b => ({
      value: String(b.branch_id),
      label: b.branch_name
    }));
    return [
        { value: '__none__', label: 'Main Lab (No Branch)' },
      { value: '__all__',  label: 'All (incl. branches)' },
     
      ...opts
    ];
  }, [branchMeta.branches]);

    const [returnTotals, setReturnTotals] = useState({
        pharmacy_returns: 0,
        ipd_returns: 0,
        lab_refunds: 0,
        opd_refunds: 0,
        total_returns: 0,
        net_collection: 0
    });
    const [users, setUsers] = useState([]);

    
    const getLocalToday = () => {
        const d = new Date();
        const yyyy = d.getFullYear();
        const mm = String(d.getMonth() + 1).padStart(2, '0');
        const dd = String(d.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
    };
    
    const [fromDate, setFromDate] = useState(getLocalToday());
    const [toDate, setToDate] = useState(getLocalToday());

    const [selectedDepartments, setSelectedDepartments] = useState([]);
    const [selectedPaymentModes, setSelectedPaymentModes] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [searchKey, setSearchKey] = useState('');

    const departmentOptions = [
        { value: 'ipd_reg', label: 'IPD Registration' },
        { value: 'ipd', label: 'IPD Billing' },
        { value: 'ipd_advance', label: 'IPD Advance' },
        { value: 'opd', label: 'OPD' },
        { value: 'opd_procedure', label: 'Procedure' },
        { value: 'emergency', label: 'Emergency' },
        { value: 'lab', label: 'Lab' },
        { value: 'pharmacy', label: 'Pharmacy' },
    ];

    const paymentModeOptions = [
        { value: 'Cash', label: 'Cash' },
        { value: 'Card', label: 'Card' },
        { value: 'Online', label: 'Online' },
    ];


    // custom (non-bootstrap) badge colors
    const CUSTOM_BADGE = {
        procedure: { background: '#fd7e14', color: '#fff' }, // purple
    };
    // Fixed department order (same as your summary badges)
const DEPT_ORDER = [
    { key: 'ipd_reg',        label: 'IPD Reg',    color: 'primary' },
    { key: 'ipd',            label: 'IPD Bill',   color: 'primary' },
    { key: 'ipd_advance',    label: 'IPD Adv',    color: 'info' },
    { key: 'opd',            label: 'OPD',        color: 'success' },
    { key: 'opd_procedure',  label: 'Procedure',  color: 'procedure' },
    { key: 'emergency',      label: 'Emergency',  color: 'danger' },
    { key: 'lab',            label: 'Lab',        color: 'warning' },
    { key: 'pharmacy',       label: 'Pharmacy',   color: 'secondary' },
    { key: 'pharmacy_return',label: 'Pharma Ret', color: 'danger', isNegative: true },
    { key: 'ipd_return',     label: 'IPD Refund', color: 'danger', isNegative: true },
    { key: 'lab_refund',     label: 'Lab Refund', color: 'danger', isNegative: true },
    { key: 'opd_refund',     label: 'OPD Refund', color: 'danger', isNegative: true },
];



// ── Procedure sub-sections, in display order ──
const PROC_TYPE_ORDER = [
    { key: 'OPD',         label: 'OPD Procedure',       color: '#198754' },
    { key: 'IPD',         label: 'IPD Procedure',       color: '#0d6efd' },
    { key: 'EMERGENCY',   label: 'Emergency Procedure', color: '#dc3545' },
    { key: 'CASUALTY',    label: 'Casualty Procedure',  color: '#fd7e14' },
    { key: 'UNSPECIFIED', label: 'Unspecified',         color: '#6c757d' },
];

const normProcType = (raw) => {
    const s = String(raw || '').trim().toLowerCase();
    if (!s) return 'UNSPECIFIED';
    if (s.includes('emerg')) return 'EMERGENCY';
    if (s.includes('casual')) return 'CASUALTY';
    if (s.includes('ipd') || s.includes('inpatient') || s.includes('in-patient')) return 'IPD';
    if (s.includes('opd') || s.includes('outpatient') || s.includes('out-patient')
        || s.includes('day care') || s.includes('daycare')) return 'OPD';
    return 'UNSPECIFIED';
};
// Split one transaction into cash/card/online buckets (same logic as filteredTotals)



    const userOptions = useMemo(() => {
        return users.map(u => ({
            value: u.user_id,
            label: u.fname + (u.lname ? ' ' + u.lname : '')
        }));
    }, [users]);
    const toMinutes = (timeStr) => {
        if (!timeStr) return null;
        const parts = String(timeStr).split(':');
        if (parts.length < 2) return null;
        const h = parseInt(parts[0], 10);
        const m = parseInt(parts[1], 10);
        if (isNaN(h) || isNaN(m)) return null;
        return h * 60 + m;
    };
    const reactSelectStyles = {
        control: (base, state) => ({
            ...base,
            minHeight: '31px',
            fontSize: '13px',
            borderColor: state.isFocused ? '#86b7fe' : '#ced4da',
            boxShadow: state.isFocused ? '0 0 0 0.25rem rgba(13,110,253,.25)' : 'none',
            '&:hover': { borderColor: '#86b7fe' },
        }),
        valueContainer: (base) => ({ ...base, padding: '0 6px' }),
        multiValue: (base) => ({ ...base, backgroundColor: '#e7f1ff', borderRadius: '3px', fontSize: '12px' }),
        multiValueLabel: (base) => ({ ...base, color: '#0d6efd', padding: '1px 4px', fontSize: '12px' }),
        multiValueRemove: (base) => ({
            ...base, color: '#0d6efd',
            ':hover': { backgroundColor: '#0d6efd', color: 'white' },
        }),
        placeholder: (base) => ({ ...base, color: '#6c757d', fontSize: '13px' }),
        menu: (base) => ({ ...base, zIndex: 9999, fontSize: '13px' }),
        option: (base, state) => ({
            ...base, fontSize: '13px', padding: '6px 10px',
            backgroundColor: state.isSelected ? '#0d6efd' : state.isFocused ? '#e7f1ff' : 'white',
            color: state.isSelected ? 'white' : '#212529',
        }),
        indicatorsContainer: (base) => ({ ...base, height: '31px' }),
        dropdownIndicator: (base) => ({ ...base, padding: '4px' }),
        clearIndicator: (base) => ({ ...base, padding: '4px' }),
    };

    const fetchTransactions = useCallback(async () => {
        setIsLoading(true);
        try {
            const fd = new FormData();
            fd.append('from_date', fromDate);
            fd.append('to_date', toDate);

            if (selectedDepartments.length === 0) {
                fd.append('department', 'all');
            } else {
                fd.append('department', selectedDepartments.map(d => d.value).join(','));
            }

            if (selectedPaymentModes.length === 0) {
                fd.append('payment_mode', 'all');
            } else {
                fd.append('payment_mode', selectedPaymentModes.map(m => m.value).join(','));
            }

            if (selectedUsers.length === 0) {
                fd.append('user_id', 'all');
            } else {
                fd.append('user_id', selectedUsers.map(u => u.value).join(','));
            }


                  // inside fetchTransactions, after the user_id append:
      fd.append('logged_user_id', ldata?.user_id || '');
      fd.append('logged_role_id', ldata?.role_id || '');
      if (selectedBranches.length > 0) {
        fd.append('branch_ids', selectedBranches.map(b => b.value).join(','));
      }

            const response = await axios.post(
                AppConst.BASE_URL + AppConst.getDaybookTransactionsUrl,
                fd,
                { headers: { 'Content-Type': 'multipart/form-data' } }
            );

            if (response?.data?.status) {
                setTransactions(response.data.transactions || []);
                setTotals(response.data.totals || { cash: 0, card: 0, online: 0, total: 0 });
                setDepartmentTotals(response.data.department_totals || {});
                setUsers(response.data.users || []);
                if (response.data.branch_meta) setBranchMeta(response.data.branch_meta);
                setReturnTotals(response.data.return_totals || {
                    pharmacy_returns: 0, ipd_returns: 0, lab_refunds: 0, opd_refunds: 0,
                    total_returns: 0, net_collection: 0
                });
                setExpensesTotal(Number(response.data.expenses_total || 0));   // ✅
                setNetAmount(Number(response.data.net_amount || 0));           // ✅
            } else {
                toast.error(response?.data?.message || 'Failed to fetch transactions');
                setTransactions([]);
            }
        } catch (error) {
            console.error('Fetch daybook error:', error);
            toast.error('Failed to fetch transactions');
            setTransactions([]);
        } finally {
            setIsLoading(false);
        }
    }, [fromDate, toDate, selectedDepartments, selectedPaymentModes, selectedUsers, selectedBranches, ldata]);

    // Only fetch transactions when on transactions tab
    useEffect(() => {
        if (activeTab === 'transactions') {
            fetchTransactions();
        }
    }, [activeTab, fetchTransactions]);

   

    const handleSearch = () => fetchTransactions();
    const handleClearSearch = () => setSearchKey('');



    // Dedupe by transaction_id (guards against backend sending a payment twice)
const uniqueTransactions = useMemo(() => {
    const seen = new Set();
    return transactions.filter(trx => {
        const key = trx.transaction_id;
        if (!key) return true;          // keep rows without an id
        if (seen.has(key)) return false; // drop duplicate
        seen.add(key);
        return true;
    });
}, [transactions]);

const filteredTransactions = useMemo(() => {
    let result = uniqueTransactions;   // was: let result = transactions;
    
        // time filter
        const fromMin = toMinutes(fromTime);
        const toMin = toMinutes(toTime);
        if (fromMin !== null || toMin !== null) {
            result = result.filter(trx => {
                const t = toMinutes(trx.payment_time);
                if (t === null) return false;
                if (fromMin !== null && t < fromMin) return false;
                if (toMin !== null && t > toMin) return false;
                return true;
            });
        }
    
        // search filter
        if (searchKey.trim()) {
            const search = searchKey.toLowerCase();
            result = result.filter(trx =>
                (trx.uhid || '').toLowerCase().includes(search) ||
                (trx.patient_name || '').toLowerCase().includes(search) ||
                (trx.received_by_name || '').toLowerCase().includes(search) ||
                (trx.department || '').toLowerCase().includes(search) ||
                (trx.transaction_id || '').toLowerCase().includes(search)
            );
        }
    
        return result;
    }, [uniqueTransactions, searchKey, fromTime, toTime]);



// Any refund/return row is always treated as NEGATIVE, whatever sign backend sends
const REFUND_KEYS = new Set(['pharmacy_return', 'ipd_return', 'lab_refund', 'opd_refund']);
const isRefund = (trx) =>
    trx.is_return || REFUND_KEYS.has(trx.dept_key) || Number(trx.payment_amount) < 0;

const signedAmount = (trx) => {
    const a = Math.abs(Number(trx.payment_amount || 0));
    return isRefund(trx) ? -a : a;
};

// Split one transaction into cash/card/online buckets (signed)
const getModeAmounts = (trx) => {
    const sign = isRefund(trx) ? -1 : 1;
    if (typeof trx.cash !== 'undefined' || typeof trx.card !== 'undefined' || typeof trx.online !== 'undefined') {
        return {
            cash: sign * Math.abs(Number(trx.cash || 0)),
            card: sign * Math.abs(Number(trx.card || 0)),
            online: sign * Math.abs(Number(trx.online || 0)),
        };
    }
    const amount = signedAmount(trx);
    const mode = (trx.payment_mode || '').toLowerCase();
    if (mode.includes('card')) return { cash: 0, card: amount, online: 0 };
    if (mode.includes('online') || mode.includes('upi')) return { cash: 0, card: 0, online: amount };
    return { cash: amount, card: 0, online: 0 };
};

// Money formatter: "- ₹700.00" or "₹700.00" — never "₹-700" or "- - "
const money = (n, sym = '₹') => `${Number(n) < 0 ? '- ' : ''}${sym}${Math.abs(Number(n || 0)).toFixed(2)}`;



// Merge all payments of the same patient (within one department) into ONE row
const groupByPatient = (rows) => {
    const map = new Map();
    rows.forEach(trx => {
        const key = `${trx.uhid || 'NA'}|${(trx.patient_name || '').trim().toUpperCase()}`;
        if (!map.has(key)) {
            map.set(key, {
                key,
                uhid: trx.uhid,
                patient_name: trx.patient_name,
                department: trx.department,
                branch_name: trx.branch_name || '',  
                cash: [], online: [], card: [],
                total: 0,
                due: null,
                dueMap: {},
            });
        }
        const p = map.get(key);
        const m = getModeAmounts(trx);
        const base = {
            transaction_id: trx.transaction_id,
            payment_date: trx.payment_date,
            payment_time: trx.payment_time,
            received_by_name: trx.received_by_name,
            payment_type: trx.payment_type || '',
        };
        if (m.cash)   p.cash.push({ ...base, amt: m.cash });
        if (m.online) p.online.push({ ...base, amt: m.online });
        if (m.card)   p.card.push({ ...base, amt: m.card });
        //if (!m.cash && !m.online && !m.card) p.cash.push({ ...base, amt: 0 });

        p.total += signedAmount(trx);

        if (trx.due_amount !== undefined && trx.due_amount !== null) {
            p.dueMap[trx.due_key || trx.transaction_id] = Number(trx.due_amount);
        }
    });
    return Array.from(map.values()).map(p => {
        const vals = Object.values(p.dueMap);
        return { ...p, due: vals.length ? vals.reduce((s, v) => s + v, 0) : null };
    });
};


const filteredTotals = useMemo(() => {
    return filteredTransactions.reduce((acc, trx) => {
        const amt = signedAmount(trx);
        const m = getModeAmounts(trx);
        acc.cash += m.cash; acc.card += m.card; acc.online += m.online;
        acc.total += amt;                       // NET (refunds already minus)
        if (amt < 0) acc.refunds += Math.abs(amt);
        else acc.gross += amt;
        return acc;
    }, { cash: 0, card: 0, online: 0, total: 0, gross: 0, refunds: 0 });
}, [filteredTransactions]);

const filteredDepartmentTotals = useMemo(() => {
    return filteredTransactions.reduce((acc, trx) => {
        const dept = trx.dept_key || '';
        if (dept) acc[dept] = (acc[dept] || 0) + signedAmount(trx);
        return acc;
    }, {});
}, [filteredTransactions]);

// Refund cards based on what's actually shown (respects search/time filters)
const filteredRefunds = useMemo(() => {
    const r = { pharmacy_return: 0, ipd_return: 0, lab_refund: 0, opd_refund: 0 };
    filteredTransactions.forEach(trx => {
        if (isRefund(trx) && r.hasOwnProperty(trx.dept_key)) {
            r[trx.dept_key] += Math.abs(Number(trx.payment_amount || 0));
        }
    });
    return r;
}, [filteredTransactions]);

/* ══════════════════════════════════════════════════════════════════════
   OPD CHARGE HEADS — Doctor Consultation vs Registration
   ──────────────────────────────────────────────────────────────────────
   opd_payment_history only holds what was COLLECTED (after discount).
   The two charge heads live in opd_tbl and are sent along on every OPD
   payment row by the backend (opd_fees / opd_reg_fees / opd_total /
   opd_discount_amt / opd_final_amt).

   Example — fees 400 + reg 100 = gross 500, discount 100:
       Doctor Consultation   400
       Registration          100
       ──────────────────────────
       Gross                 500
       Discount             -100
       Net payable           400   ← matches what can be collected

   Each head is shown exactly as stored. The discount is its OWN line and is
   not attributed to either head — who it comes off is decided later; this
   report only displays it.

   DISCOUNT: opd_discount is a PERCENTAGE, opd_discount_amt is a RUPEE amount.
   Either may be the one that is filled, so the amount is used when present and
   the percentage is applied to the gross otherwise.

   Charges are counted ONCE per opd_id even when a visit has several
   payments; the collected figure sums every payment.
   ══════════════════════════════════════════════════════════════════════ */
const opdFeeSummary = useMemo(() => {
    const seen = new Set();
    const s = {
        visits: 0,
        consultation: 0, registration: 0,
        gross: 0, discount: 0, net: 0,
        collected: 0,
        pctVisits: 0,          // how many visits were discounted by %
    };

    filteredTransactions.forEach(trx => {
        if (trx.dept_key !== 'opd') return;

        s.collected += signedAmount(trx);

        const id = trx.opd_id ?? trx.payment_opd_id;
        if (!id || seen.has(String(id))) return;   // count charges once per visit
        seen.add(String(id));

        const fees  = Number(trx.opd_fees || 0);
        const reg   = Number(trx.opd_reg_fees || 0);
        const gross = Number(trx.opd_total || 0) || (fees + reg);

        // discount: rupee amount wins, else percentage of gross
        let disc = Number(trx.opd_discount_value || 0);
        if (!disc) {
            const amt = Number(trx.opd_discount_amt || 0);
            const pct = Number(trx.opd_discount_pct ?? trx.opd_discount ?? 0);
            disc = amt > 0 ? amt : (pct > 0 ? (gross * pct) / 100 : 0);
            if (!(amt > 0) && pct > 0) s.pctVisits += 1;
        }

        s.consultation += fees;
        s.registration += reg;
        s.gross        += gross;
        s.discount     += disc;
        s.net          += Number(trx.opd_final_amt || 0) || (gross - disc);
        s.visits       += 1;
    });

    return s;
}, [filteredTransactions]);



  


    const groupedTransactions = useMemo(() => {
        const map = {};
        filteredTransactions.forEach(trx => {
            const key = trx.dept_key || 'other';
            (map[key] = map[key] || []).push(trx);
        });
    
        const known = new Set(DEPT_ORDER.map(d => d.key));
        const ordered = DEPT_ORDER
            .filter(d => map[d.key] && map[d.key].length)
            .map(d => ({ ...d, rows: map[d.key] }));
    
        // any dept_key not in DEPT_ORDER goes to the end
        Object.keys(map).forEach(k => {
            if (!known.has(k)) ordered.push({ key: k, label: k, color: 'dark', rows: map[k] });
        });
    
     
       const sumRows = (rows) => rows.reduce((a, t) => {
        const m = getModeAmounts(t);
        a.cash += m.cash; a.card += m.card; a.online += m.online;
        a.total += signedAmount(t);
        return a;
    }, { cash: 0, card: 0, online: 0, total: 0 });

    return ordered.map(g => {
        const sub = sumRows(g.rows);

        const patients = groupByPatient(g.rows);
        const dueMap = {};
        patients.forEach(p => Object.assign(dueMap, p.dueMap));
        sub.due = Object.values(dueMap).reduce((s, v) => s + v, 0);

        // ✅ Procedure → split by patient type (OPD / IPD / Emergency / Casualty)
        let subGroups = null;
        if (g.key === 'opd_procedure') {
            const byType = {};
            g.rows.forEach(t => {
                const k = normProcType(t.patient_type ?? t.proc_type);
                (byType[k] = byType[k] || []).push(t);
            });
            subGroups = PROC_TYPE_ORDER
                .filter(t => byType[t.key] && byType[t.key].length)
                .map(t => ({
                    ...t,
                    rows: byType[t.key],
                    patients: groupByPatient(byType[t.key]),
                    sub: sumRows(byType[t.key]),
                }));
        }

        return { ...g, sub, patients, dueMap, subGroups };
    });
}, [filteredTransactions]);




    const formatDate = (dateStr) => {
        if (!dateStr) return 'N/A';
    
        // Pull just the date part if a datetime came through ("2026-08-28 00:17:00")
        const datePart = String(dateStr).trim().split(/[ T]/)[0];
        const m = datePart.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    
        let date;
        if (m) {
            // Build as LOCAL date — no UTC shift
            date = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
        } else {
            date = new Date(dateStr);
        }
        if (isNaN(date)) return dateStr;
    
        return date.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
    };

    const formatTime = (timeStr) => {
        if (!timeStr) return '';
        try {
            const parts = timeStr.split(':');
            if (parts.length < 2) return timeStr;
            const h = parseInt(parts[0]);
            const m = parts[1];
            const ampm = h >= 12 ? 'PM' : 'AM';
            return `${h % 12 || 12}:${m} ${ampm}`;
        } catch { return timeStr; }
    };

    const getDeptBadgeClass = (dept) => {
        const classes = {
            'IPD Billing': 'bg-primary',
            'IPD Advance': 'bg-info',
            'IPD Refund': 'bg-danger',
            'OPD': 'bg-success',
            // 'OPD Procedure': 'bg-success',
            'Procedure': 'bg-success',
            'OPD Refund': 'bg-danger',
            'Emergency': 'bg-danger',
            'Lab': 'bg-warning text-dark',
            'Lab Payment': 'bg-warning text-dark',
            'Lab Refund': 'bg-danger',
            'Pharmacy': 'bg-secondary',
            'Pharmacy Payment': 'bg-secondary',
            'Pharmacy Return': 'bg-danger'
        };
        return classes[dept] || 'bg-dark';
    };

    const getPaymentModeBadge = (mode) => {
        const m = (mode || '').toLowerCase();
        if (m.includes('cash')) return <span className="badge bg-success">Cash</span>;
        if (m.includes('card')) return <span className="badge bg-primary">Card</span>;
        if (m.includes('online') || m.includes('upi')) return <span className="badge bg-info">Online</span>;
        return <span className="badge bg-secondary">{mode || 'Cash'}</span>;
    };

    // const handlePrintPDF = () => {
    //     const doc = new jsPDF();
    //     const pageWidth = doc.internal.pageSize.getWidth();
    //     const pageHeight = doc.internal.pageSize.getHeight();
    
    //     doc.setFontSize(16).setFont('helvetica', 'bold');
    //     doc.text('DAYBOOK REPORT', pageWidth / 2, 15, { align: 'center' });
    //     doc.setFontSize(10).setFont('helvetica', 'normal');
    //     doc.text(`Date: ${formatDate(fromDate)} to ${formatDate(toDate)}`, pageWidth / 2, 22, { align: 'center' });
    
    //     let startY = 30;
    
    //     groupedTransactions.forEach(group => {
    //         // new page if not enough room for header + a couple rows
    //         if (startY > pageHeight - 40) { doc.addPage(); startY = 20; }
    
    //         // section header
    //         doc.setFontSize(11).setFont('helvetica', 'bold');
    //         doc.text(group.label, 14, startY);
    
    //         const body = group.rows.map((trx, idx) => [
    //             idx + 1,
    //             trx.uhid || 'N/A',
    //             (trx.patient_name || 'N/A').substring(0, 20),
    //             formatDate(trx.payment_date),
    //             formatTime(trx.payment_time),
    //             trx.payment_mode || 'Cash',
    //             `${Number(trx.payment_amount || 0) < 0 ? '- ' : ''}Rs.${Math.abs(Number(trx.payment_amount || 0)).toFixed(2)}`,
    //             (trx.received_by_name || 'N/A').substring(0, 14)
    //         ]);
    
    //         autoTable(doc, {
    //             startY: startY + 2,
    //             head: [['#', 'UHID', 'Patient', 'Date', 'Time', 'Mode', 'Amount', 'Received']],
    //             body,
    //             theme: 'grid',
    //             headStyles: { fillColor: [64, 81, 137], fontSize: 8 },
    //             styles: { fontSize: 7, cellPadding: 1.5 },
    //             columnStyles: { 6: { halign: 'right' } }
    //         });
    
    //         // per-department summary (cash / card / online / subtotal)
    //         autoTable(doc, {
    //             startY: doc.lastAutoTable.finalY + 1,
    //             body: [[
    //                 `${group.label} Summary`,
    //                 `Cash Rs.${group.sub.cash.toFixed(2)}`,
    //                 `Card Rs.${group.sub.card.toFixed(2)}`,
    //                 `Online Rs.${group.sub.online.toFixed(2)}`,
    //                 `Subtotal Rs.${group.sub.total.toFixed(2)}`
    //             ]],
    //             theme: 'grid',
    //             styles: { fontSize: 8, fontStyle: 'bold', fillColor: [240, 240, 240] },
    //             columnStyles: { 4: { halign: 'right' } }
    //         });
    
    //         startY = doc.lastAutoTable.finalY + 8;
    //     });
    
    //     // grand total
    //     if (startY > pageHeight - 45) { doc.addPage(); startY = 20; }
    //     doc.setFontSize(12).setFont('helvetica', 'bold');
    //     doc.text('GRAND TOTAL', 14, startY);
    //     autoTable(doc, {
    //         startY: startY + 3,
    //         body: [
    //             ['Cash', `Rs.${filteredTotals.cash.toFixed(2)}`],
    //             ['Card', `Rs.${filteredTotals.card.toFixed(2)}`],
    //             ['Online', `Rs.${filteredTotals.online.toFixed(2)}`],
    //             ['TOTAL', `Rs.${filteredTotals.total.toFixed(2)}`]
    //         ],
    //         theme: 'grid',
    //         styles: { fontSize: 10 },
    //         columnStyles: { 1: { halign: 'right' } },
    //         margin: { left: 14 }
    //     });
    


    //             // Expenses + Net Amount
    //             startY = doc.lastAutoTable.finalY + 6;
    //             autoTable(doc, {
    //                 startY,
    //                 body: [
    //                     ['Total Collection', `Rs.${filteredTotals.total.toFixed(2)}`],
    //                     ['Total Expenses', `- Rs.${Number(expensesTotal).toFixed(2)}`],
    //                     ['NET AMOUNT (IN HAND)', `Rs.${Number(filteredTotals.total - expensesTotal).toFixed(2)}`]
    //                 ],
    //                 theme: 'grid',
    //                 styles: { fontSize: 10, fontStyle: 'bold' },
    //                 columnStyles: { 1: { halign: 'right' } },
    //                 margin: { left: 14 }
    //             });
    //     const pdfBlob = doc.output('blob');
    //     window.open(URL.createObjectURL(pdfBlob), '_blank');
    // };



    // ===== OLD handlePrintPDF (one row per transaction) — kept for reference =====
// const handlePrintPDF = () => { ... old code ... };
// ==========================================================================

const handlePrintPDF = () => {
    const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const R = (n) => money(n, 'Rs.');           // jsPDF default font has no ₹ symbol

    // ---------- Header ----------
    doc.setFontSize(16).setFont('helvetica', 'bold');
    doc.text('DAYBOOK REPORT', pageWidth / 2, 12, { align: 'center' });
    doc.setFontSize(9).setFont('helvetica', 'normal');
    let sub = `Date: ${formatDate(fromDate)} to ${formatDate(toDate)}`;
    if (fromTime || toTime) sub += `   |   Time: ${fromTime ? formatTime(fromTime) : 'Start'} to ${toTime ? formatTime(toTime) : 'End'}`;
    doc.text(sub, pageWidth / 2, 18, { align: 'center' });
    doc.setFontSize(7).setTextColor(120);
    doc.text(`Printed: ${new Date().toLocaleString('en-IN')}`, pageWidth - 10, 18, { align: 'right' });
    doc.setTextColor(0);

    // ---------- Cell text: "Rs.total" then each payment ----------
    const payCellText = (items) => {
        if (!items.length) return '-';
        const sum = items.reduce((s, i) => s + i.amt, 0);
        const lines = [R(sum)];
        items.forEach(it => {
            lines.push(`${formatDate(it.payment_date)}, ${formatTime(it.payment_time)}`);
            lines.push(`${R(it.amt)}  -  ${(it.received_by_name || 'N/A').substring(0, 18)}`);
        });
        return lines.join('\n');
    };

    // ---------- Build body ----------
    // Mirrors the on-screen table exactly: Dept column, and IPD patients with
    // both a bill and an investigation payment are stacked as
    //   IPD Bill → Investigation → Combined
    // (identity printed on the first line of the block, blank on the rest, so
    //  the block never breaks badly across a page boundary).
    const body = [];
    let serial = 0;

    const isLabItem = (it) => /lab|investigation/i.test(it.payment_type || '');
    const splitArr  = (arr) => ({
        bill: (arr || []).filter(it => !isLabItem(it)),
        lab:  (arr || []).filter(it =>  isLabItem(it)),
    });
    const sumAmt = (arr) => arr.reduce((s, i) => s + i.amt, 0);

    groupedTransactions.forEach(group => {
        // group header row
        body.push([{
            content: `${group.label}   (${group.patients.length} patient${group.patients.length !== 1 ? 's' : ''}, ${group.rows.length} payments)`,
            colSpan: 9,
            styles: { fillColor: [220, 224, 235], fontStyle: 'bold', fontSize: 8, textColor: [40, 50, 90] },
        }]);



        // ✅ PROCEDURE → sub-sections per patient type
        if (group.subGroups) {
            group.subGroups.forEach(sg => {
                body.push([{
                    content: `        ${sg.label}   (${sg.patients.length} patient${sg.patients.length !== 1 ? 's' : ''}, ${sg.rows.length} payments)`,
                    colSpan: 9,
                    styles: { fillColor: [236, 240, 248], fontStyle: 'bold', fontSize: 7.5, textColor: [60, 70, 110] },
                }]);

                sg.patients.forEach(p => {
                    serial++;
                    body.push([
                        { content: serial, styles: { halign: 'center' } },
                        { content: p.uhid || 'N/A', styles: { fontStyle: 'bold', textColor: [13, 110, 253] } },
                        (p.patient_name || 'N/A').substring(0, 28),
                        { content: sg.label, styles: { fontSize: 6.5 } },
                        payCellText(p.cash),
                        payCellText(p.online),
                        payCellText(p.card),
                        { content: R(p.total), styles: { fontStyle: 'bold', halign: 'right', textColor: p.total < 0 ? [200, 0, 0] : [0, 0, 0] } },
                        { content: p.due === null ? '-' : R(p.due), styles: { halign: 'right', textColor: p.due > 0 ? [200, 0, 0] : [120, 120, 120] } },
                    ]);
                });

                const sgStyle = { fillColor: [238, 242, 248], fontStyle: 'bold', fontSize: 7.5 };
                body.push([
                    { content: `${sg.label} Total`, colSpan: 4, styles: { ...sgStyle, halign: 'right' } },
                    { content: R(sg.sub.cash), styles: sgStyle },
                    { content: R(sg.sub.online), styles: sgStyle },
                    { content: R(sg.sub.card), styles: sgStyle },
                    { content: R(sg.sub.total), styles: { ...sgStyle, halign: 'right', textColor: [13, 110, 253] } },
                    { content: '', styles: sgStyle },
                ]);
            });

            // whole-group total, then skip the flat patient loop below
            const procStyle = { fillColor: [220, 228, 242], fontStyle: 'bold', fontSize: 8 };
            body.push([
                { content: 'PROCEDURES TOTAL', colSpan: 4, styles: { ...procStyle, halign: 'right' } },
                { content: R(group.sub.cash), styles: procStyle },
                { content: R(group.sub.online), styles: procStyle },
                { content: R(group.sub.card), styles: procStyle },
                { content: R(group.sub.total), styles: { ...procStyle, halign: 'right', textColor: [13, 110, 253] } },
                { content: '', styles: procStyle },
            ]);
            return;
        }

        // patient rows
        group.patients.forEach(p => {
            serial++;

            const cash   = splitArr(p.cash);
            const online = splitArr(p.online);
            const card   = splitArr(p.card);
            const billTotal = sumAmt(cash.bill) + sumAmt(online.bill) + sumAmt(card.bill);
            const labTotal  = sumAmt(cash.lab)  + sumAmt(online.lab)  + sumAmt(card.lab);
            const hasBill = (cash.bill.length || online.bill.length || card.bill.length) > 0;
            const hasLab  = (cash.lab.length  || online.lab.length  || card.lab.length)  > 0;

            const dueCell = {
                content: p.due === null ? '-' : R(p.due),
                styles: { fontStyle: 'bold', halign: 'right', textColor: p.due > 0 ? [200, 0, 0] : [120, 120, 120] },
            };

            // ✅ IPD with BOTH bill + investigation → stacked block, same as the UI
            if (group.key === 'ipd' && hasBill && hasLab) {
                const billFill = { fillColor: [238, 243, 255] };
                const labFill  = { fillColor: [255, 248, 225] };
                const combFill = { fillColor: [233, 236, 239], fontStyle: 'bold' };

                // row 1 — IPD Bill (carries the patient identity)
                body.push([
                    { content: serial, styles: { ...billFill, halign: 'center' } },
                    { content: p.uhid || 'N/A', styles: { ...billFill, fontStyle: 'bold', textColor: [13, 110, 253] } },
                    { content: (p.patient_name || 'N/A').substring(0, 28), styles: billFill },
                    { content: 'IPD Bill', styles: { ...billFill, fontStyle: 'bold', textColor: [13, 110, 253] } },
                    { content: payCellText(cash.bill), styles: billFill },
                    { content: payCellText(online.bill), styles: billFill },
                    { content: payCellText(card.bill), styles: billFill },
                    { content: R(billTotal), styles: { ...billFill, halign: 'right', fontStyle: 'bold', textColor: [13, 110, 253] } },
                    { ...dueCell, styles: { ...dueCell.styles, ...billFill } },
                ]);

                // row 2 — Investigation
                body.push([
                    { content: '', styles: labFill },
                    { content: '', styles: labFill },
                    { content: '', styles: labFill },
                    { content: 'Investigation', styles: { ...labFill, fontStyle: 'bold', textColor: [150, 90, 0] } },
                    { content: payCellText(cash.lab), styles: labFill },
                    { content: payCellText(online.lab), styles: labFill },
                    { content: payCellText(card.lab), styles: labFill },
                    { content: R(labTotal), styles: { ...labFill, halign: 'right', fontStyle: 'bold', textColor: [150, 90, 0] } },
                    { content: '', styles: labFill },
                ]);

                // row 3 — Combined
                body.push([
                    { content: 'Combined (IPD + Investigation):', colSpan: 7, styles: { ...combFill, halign: 'right' } },
                    { content: R(billTotal + labTotal), styles: { ...combFill, halign: 'right', textColor: [13, 110, 253] } },
                    { content: '', styles: combFill },
                ]);

                return;
            }

            // Default: one row per patient
            const deptLabel = p.branch_name
                ? `${p.department || ''}\n(${p.branch_name})`
                : (p.department || '');

            body.push([
                { content: serial, styles: { halign: 'center' } },
                { content: p.uhid || 'N/A', styles: { fontStyle: 'bold', textColor: [13, 110, 253] } },
                (p.patient_name || 'N/A').substring(0, 28),
                { content: deptLabel, styles: { fontSize: 6.5 } },
                payCellText(p.cash),
                payCellText(p.online),
                payCellText(p.card),
                { content: R(p.total), styles: { fontStyle: 'bold', halign: 'right', textColor: p.total < 0 ? [200, 0, 0] : [0, 0, 0] } },
                dueCell,
            ]);
        });

        // group subtotal row
        const subStyle = { fillColor: [245, 245, 245], fontStyle: 'bold', fontSize: 7.5 };
        body.push([
            { content: `${group.label} Subtotal`, colSpan: 4, styles: { ...subStyle, halign: 'right' } },
            { content: R(group.sub.cash), styles: subStyle },
            { content: R(group.sub.online), styles: subStyle },
            { content: R(group.sub.card), styles: subStyle },
            { content: R(group.sub.total), styles: { ...subStyle, halign: 'right', textColor: group.sub.total < 0 ? [200, 0, 0] : [0, 0, 0] } },
            { content: group.sub.due ? R(group.sub.due) : '-', styles: { ...subStyle, halign: 'right', textColor: [200, 0, 0] } },
        ]);

        // ✅ OPD charge heads — consultation + registration, under the OPD subtotal
        if (group.key === 'opd' && opdFeeSummary.visits > 0) {
            const headStyle = { fillColor: [240, 247, 255], fontStyle: 'bold', fontSize: 7.5 };
            const sumStyle  = { fillColor: [231, 241, 255], fontStyle: 'bold', fontSize: 8 };

            body.push([
                { content: `Doctor Consultation Charges   (${opdFeeSummary.visits} visit${opdFeeSummary.visits !== 1 ? 's' : ''})`, colSpan: 7, styles: { ...headStyle, halign: 'right' } },
                { content: R(opdFeeSummary.consultation), styles: { ...headStyle, halign: 'right' } },
                { content: '', styles: headStyle },
            ]);

            body.push([
                { content: 'Registration Charges', colSpan: 7, styles: { ...headStyle, halign: 'right' } },
                { content: R(opdFeeSummary.registration), styles: { ...headStyle, halign: 'right' } },
                { content: '', styles: headStyle },
            ]);

            body.push([
                { content: 'Gross (Consultation + Registration)', colSpan: 7, styles: { ...sumStyle, halign: 'right' } },
                { content: R(opdFeeSummary.gross), styles: { ...sumStyle, halign: 'right' } },
                { content: '', styles: sumStyle },
            ]);

            if (opdFeeSummary.discount > 0) {
                const discStyle = { fillColor: [255, 248, 225], fontStyle: 'bold', fontSize: 7.5, textColor: [200, 0, 0] };
                const discLabel = opdFeeSummary.pctVisits > 0
                    ? `Less: Discount   (${opdFeeSummary.pctVisits} by %)`
                    : 'Less: Discount';
                body.push([
                    { content: discLabel, colSpan: 7, styles: { ...discStyle, halign: 'right' } },
                    { content: `- Rs.${opdFeeSummary.discount.toFixed(2)}`, styles: { ...discStyle, halign: 'right' } },
                    { content: '', styles: discStyle },
                ]);
            }

            body.push([
                { content: 'Net Payable (after discount)', colSpan: 7, styles: { ...sumStyle, halign: 'right' } },
                { content: R(opdFeeSummary.net), styles: { ...sumStyle, halign: 'right' } },
                { content: opdFeeSummary.net - opdFeeSummary.collected > 0 ? R(opdFeeSummary.net - opdFeeSummary.collected) : '-', styles: { ...sumStyle, halign: 'right', textColor: [200, 0, 0] } },
            ]);
        }
    });

    // grand due (each bill counted once)
    const grandDue = Object.values(Object.assign({}, ...groupedTransactions.map(g => g.dueMap || {})))
        .reduce((s, v) => s + v, 0);

    // ---------- Main table ----------
    autoTable(doc, {
        startY: 22,
        head: [['#', 'UHID', 'Patient', 'Dept', 'Cash', 'Online', 'Card', 'Total', 'Due']],
        body,
        foot: [[
            { content: 'GRAND TOTAL', colSpan: 4, styles: { halign: 'right' } },
            R(filteredTotals.cash),
            R(filteredTotals.online),
            R(filteredTotals.card),
            { content: R(filteredTotals.total), styles: { halign: 'right' } },
            { content: R(grandDue), styles: { halign: 'right' } },
        ]],
        showHead: 'everyPage',
        showFoot: 'lastPage',
        theme: 'grid',
        margin: { left: 10, right: 10, bottom: 14 },
        headStyles: { fillColor: [64, 81, 137], fontSize: 8, halign: 'center' },
        footStyles: { fillColor: [64, 81, 137], textColor: 255, fontStyle: 'bold', fontSize: 8 },
        styles: { fontSize: 7, cellPadding: 1.5, valign: 'top', overflow: 'linebreak' },
        columnStyles: {
            0: { cellWidth: 8,  halign: 'center' },   // #
            1: { cellWidth: 22 },                     // UHID
            2: { cellWidth: 34 },                     // Patient
            3: { cellWidth: 22 },                     // Dept
            4: { cellWidth: 52 },                     // Cash
            5: { cellWidth: 52 },                     // Online
            6: { cellWidth: 42 },                     // Card
            7: { cellWidth: 24, halign: 'right' },    // Total
            8: { cellWidth: 21, halign: 'right' },    // Due
        },
        // make the first line (mode total) of Cash/Online/Card cells bold-looking via colour
        didParseCell: (data) => {
            if (data.section === 'body' && [4, 5, 6].includes(data.column.index) && data.cell.text?.length > 1) {
                data.cell.styles.textColor = [30, 30, 30];
            }
        },
        didDrawPage: () => {
            const pg = doc.internal.getCurrentPageInfo().pageNumber;
            doc.setFontSize(7).setTextColor(120);
            doc.text(`Page ${pg}`, pageWidth - 10, pageHeight - 6, { align: 'right' });
            doc.setTextColor(0);
        },
    });

    // ---------- Summary ----------
    let startY = doc.lastAutoTable.finalY + 6;
    if (startY > pageHeight - 50) { doc.addPage(); startY = 15; }

    const exp = Math.abs(Number(expensesTotal || 0));
    doc.setFontSize(11).setFont('helvetica', 'bold');
    doc.text('SUMMARY', 10, startY);

    autoTable(doc, {
        startY: startY + 2,
        body: [
            ['Gross Collection', R(filteredTotals.gross)],
            ['Total Refunds', `- Rs.${filteredTotals.refunds.toFixed(2)}`],
            ['Net Collection', R(filteredTotals.total)],
            ['Total Expenses', `- Rs.${exp.toFixed(2)}`],
            [{ content: 'NET AMOUNT (IN HAND)', styles: { fillColor: [33, 37, 41], textColor: 255 } },
             { content: R(filteredTotals.total - exp), styles: { fillColor: [33, 37, 41], textColor: 255 } }],
            [{ content: 'Total Due (Pending)', styles: { textColor: [200, 0, 0] } },
             { content: R(grandDue), styles: { textColor: [200, 0, 0] } }],
        ],
        theme: 'grid',
        tableWidth: 100,
        margin: { left: 10 },
        styles: { fontSize: 9, fontStyle: 'bold', cellPadding: 2 },
        columnStyles: { 1: { halign: 'right' } },
    });

    const pdfBlob = doc.output('blob');
    window.open(URL.createObjectURL(pdfBlob), '_blank');
};

    const renderPayCell = (items, mode) => {
    if (!items.length) return <span className="text-muted">—</span>;
    const sum = items.reduce((s, i) => s + i.amt, 0);
    return (
        <div>
            <div className="d-flex justify-content-between align-items-center">
                {getPaymentModeBadge(mode)}
                <strong className={sum < 0 ? 'text-danger' : 'text-success'}>{money(sum)}</strong>
            </div>
            {items.map((it, i) => (
                <div key={it.transaction_id || i} className="border-top mt-1 pt-1" style={{ fontSize: '10px', lineHeight: 1.35 }}>
                    <div className="text-muted">
                        <i className="ri-calendar-line"></i> {formatDate(it.payment_date)} · {formatTime(it.payment_time)}
                    </div>
                    <div className={`fw-bold ${it.amt < 0 ? 'text-danger' : ''}`}>{money(it.amt)}</div>
                    <div className="text-muted"><i className="ri-user-line"></i> {it.received_by_name || 'N/A'}</div>
                </div>
            ))}
        </div>
    );
};


    return (
        <div className="page-content">
            <div className="container-fluid">
                {/* Header */}
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 style={{ color: '#405189' }}>
                        <i className="ri-book-2-line me-2"></i>Daybook
                    </h4>
                    {activeTab === 'transactions' && (
                        <button className="btn btn-primary btn-sm" onClick={handlePrintPDF}>
                            <i className="ri-printer-line me-1"></i> Print
                        </button>
                    )}
                </div>

                {/* TABS */}
                <ul className="nav nav-tabs mb-3" role="tablist">
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === 'transactions' ? 'active fw-bold' : ''}`}
                            onClick={() => setActiveTab('transactions')}
                            style={{ cursor: 'pointer' }}
                        >
                            <i className="ri-exchange-line me-1"></i>
                            All Transactions
                            {activeTab === 'transactions' && (
                                <span className="badge bg-primary ms-2">{filteredTransactions.length}</span>
                            )}
                        </button>
                    </li>
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === 'balance' ? 'active fw-bold' : ''}`}
                            onClick={() => setActiveTab('balance')}
                            style={{ cursor: 'pointer' }}
                        >
                            <i className="ri-hand-coin-line me-1"></i>
                            Balance Sheet
                            {balanceCount > 0 && (
                                <span className="badge bg-danger ms-2">{balanceCount}</span>
                            )}
                        </button>
                    </li>
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === 'ipd_net' ? 'active fw-bold' : ''}`}
                            onClick={() => setActiveTab('ipd_net')}
                            style={{ cursor: 'pointer' }}
                        >
                            <i className="ri-hospital-line me-1"></i>
                            IPD Net Collection
                            {activeTab === 'ipd_net' && ipdNetCount > 0 && (
                                <span className="badge bg-info ms-2">{ipdNetCount}</span>
                            )}
                        </button>
                    </li>
                </ul>

                {/* ============================================ */}
                {/* TAB 1: ALL TRANSACTIONS                       */}
                {/* ============================================ */}
                {activeTab === 'transactions' && (
                    <>
                        {/* Filters */}
                        <div className="card mb-3">
                            <div className="card-body py-2">
                                <div className="row g-2 align-items-end">
                                <div className="col-lg-2 col-md-4 col-6">
    <label className="form-label small mb-1">From</label>
    <input type="date" className="form-control form-control-sm" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
</div>
<div className="col-lg-2 col-md-4 col-6">
    <label className="form-label small mb-1">To</label>
    <input type="date" className="form-control form-control-sm" value={toDate} onChange={(e) => setToDate(e.target.value)} />
</div>

{/* NEW: time filters */}
<div className="col-lg-1 col-md-4 col-6">
    <label className="form-label small mb-1">From Time</label>
    <input type="time" className="form-control form-control-sm" value={fromTime} onChange={(e) => setFromTime(e.target.value)} />
</div>
<div className="col-lg-1 col-md-4 col-6">
    <label className="form-label small mb-1">To Time</label>
    <input type="time" className="form-control form-control-sm" value={toTime} onChange={(e) => setToTime(e.target.value)} />
</div>




{!branchMeta.is_branch_user && (
                                    <div className="col-lg-2 col-md-4 col-6">
                                        <label className="form-label small mb-1">Department</label>
                                        <Select
                                            isMulti
                                            options={departmentOptions}
                                            value={selectedDepartments}
                                            onChange={(selected) => setSelectedDepartments(selected || [])}
                                            placeholder="All Departments"
                                            isClearable
                                            styles={reactSelectStyles}
                                            closeMenuOnSelect={false}
                                        />
                                    </div>


)}

                                    <div className="col-lg-2 col-md-4 col-6">
                                        <label className="form-label small mb-1">Mode</label>
                                        <Select
                                            isMulti
                                            options={paymentModeOptions}
                                            value={selectedPaymentModes}
                                            onChange={(selected) => setSelectedPaymentModes(selected || [])}
                                            placeholder="All Modes"
                                            isClearable
                                            styles={reactSelectStyles}
                                            closeMenuOnSelect={false}
                                        />
                                    </div>

                                    <div className="col-lg-3 col-md-4 col-6">
                                        <label className="form-label small mb-1">User</label>
                                        <Select
                                            isMulti
                                            options={userOptions}
                                            value={selectedUsers}
                                            onChange={(selected) => setSelectedUsers(selected || [])}
                                            placeholder="All Users"
                                            isClearable
                                            isSearchable
                                            styles={reactSelectStyles}
                                            closeMenuOnSelect={false}
                                        />
                                    </div>


                                    {branchMeta.is_admin && branchMeta.branches_exist && (
  <div className="col-lg-2 col-md-4 col-6">
    <label className="form-label small mb-1">Branch (Lab)</label>
    <Select
      isMulti
      options={branchOptions}
      value={selectedBranches}
      onChange={(s) => setSelectedBranches(s || [])}
      placeholder="Main Lab (No Branch)"
      isClearable
      styles={reactSelectStyles}
      closeMenuOnSelect={false}
    />
  </div>
)}

                                    <div className="col-lg-1 col-md-4 col-6">
                                        <button className="btn btn-primary btn-sm w-100" onClick={handleSearch} disabled={isLoading}>
                                            {isLoading ? <span className="spinner-border spinner-border-sm"></span> : <><i className="ri-search-line me-1"></i>Search</>}
                                        </button>
                                    </div>
                                </div>

                                <div className="row mt-3">
                                    <div className="col-md-6">
                                        <div className="input-group input-group-sm">
                                            <span className="input-group-text bg-light">
                                                <i className="ri-search-line"></i>
                                            </span>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="🔍 Search by UHID, Patient Name, Department..."
                                                value={searchKey}
                                                onChange={(e) => setSearchKey(e.target.value)}
                                            />
                                            {searchKey && (
                                                <button className="btn btn-outline-secondary" type="button" onClick={handleClearSearch}>
                                                    <i className="ri-close-line"></i>
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-md-6 d-flex align-items-center">
                                        <small className="text-muted">
                                            {searchKey || selectedDepartments.length > 0 || selectedPaymentModes.length > 0 || selectedUsers.length > 0 ? (
                                                <>Showing <strong>{filteredTransactions.length}</strong> of <strong>{transactions.length}</strong> transactions</>
                                            ) : (
                                                <><strong>{filteredTransactions.length}</strong> transactions</>
                                            )}
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Summary Cards */}
                        <div className="row mb-3 g-2">
                            <div className="col-md-3 col-6">
                                <div className="card border-success h-100">
                                    <div className="card-body text-center py-2">
                                        <small className="text-muted">Cash</small>
                                        <h5 className="text-success mb-0">₹{filteredTotals.cash.toFixed(2)}</h5>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3 col-6">
                                <div className="card border-primary h-100">
                                    <div className="card-body text-center py-2">
                                        <small className="text-muted">Card</small>
                                        <h5 className="text-primary mb-0">₹{filteredTotals.card.toFixed(2)}</h5>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3 col-6">
                                <div className="card border-info h-100">
                                    <div className="card-body text-center py-2">
                                        <small className="text-muted">Online</small>
                                        <h5 className="text-info mb-0">₹{filteredTotals.online.toFixed(2)}</h5>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3 col-6">
                                <div className="card bg-primary text-white h-100">
                                    <div className="card-body text-center py-2">
                                        <small className="text-white-50">Total</small>
                                        <h5 className="text-white mb-0">₹{filteredTotals.total.toFixed(2)}</h5>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Department Summary */}
                        <div className="card mb-3">
                            <div className="card-body py-2">
                                <div className="d-flex flex-wrap justify-content-around text-center gap-2">
                                    {[
                                        { key: 'ipd_reg', label: 'IPD Reg', color: 'primary' },
                                        { key: 'ipd', label: 'IPD Bill', color: 'primary' },
                                        { key: 'ipd_advance', label: 'IPD Adv', color: 'info' },
                                        { key: 'opd', label: 'OPD', color: 'success' },
                                        { key: 'opd_procedure', label: 'Procedure', color: 'procedure' },
                                        { key: 'emergency', label: 'Emergency', color: 'danger' },
                                        { key: 'lab', label: 'Lab', color: 'warning' },
                                        { key: 'pharmacy', label: 'Pharmacy', color: 'secondary' },
                                        { key: 'pharmacy_return', label: 'Pharma Ret', color: 'danger', isNegative: true },
                                        { key: 'ipd_return', label: 'IPD Refund', color: 'danger', isNegative: true },
                                        { key: 'lab_refund', label: 'Lab Refund', color: 'danger', isNegative: true },
                                        { key: 'opd_refund', label: 'OPD Refund', color: 'danger', isNegative: true }
                                    ].map(d => (
                                        <div key={d.key}>
                                        <span
                                            className={`badge ${CUSTOM_BADGE[d.color] ? '' : `bg-${d.color} ${d.color === 'warning' ? 'text-dark' : ''}`}`}
                                            style={{ fontSize: '10px', ...(CUSTOM_BADGE[d.color] || {}) }}
                                        >{d.label}</span>
                                            <div className={`small fw-bold ${d.isNegative ? 'text-danger' : ''}`}>
                                                {d.isNegative ? '- ' : ''}₹{Math.abs(filteredDepartmentTotals[d.key] || 0).toFixed(2)}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        {/* Transactions Table */}
                        <div className="card">
                            <div className="card-body p-0">
                                <div className="table-responsive" style={{ maxHeight: '400px' }}>
                                    {/* ===== <table className="table table-sm table-hover table-striped mb-0" style={{ fontSize: '11px' }}>
                                        <thead className="table-dark sticky-top">
                                            <tr>
                                                <th>#</th>
                                                <th>UHID</th>
                                                <th>Patient</th>
                                                <th>Dept</th>
                                                <th>Date</th>
                                                <th>Time</th>
                                                <th>Mode</th>
                                                <th className="text-end">Amount</th>
                                                <th>Received By</th>
                                            </tr>
                                        </thead>
                                        <tbody>
    {isLoading ? (
        <tr><td colSpan="9" className="text-center py-3"><div className="spinner-border spinner-border-sm"></div></td></tr>
    ) : filteredTransactions.length === 0 ? (
        <tr><td colSpan="9" className="text-center py-3 text-muted">
            {searchKey ? `No transactions found for "${searchKey}"` : 'No transactions'}
        </td></tr>
    ) : (() => {
        let serial = 0;
        return groupedTransactions.map(group => (
            <React.Fragment key={group.key}>
               
                <tr className="table-secondary">
                    <td colSpan="9" className="fw-bold">
                    <span
                            className={`badge me-2 ${CUSTOM_BADGE[group.color] ? '' : `bg-${group.color} ${group.color === 'warning' ? 'text-dark' : ''}`}`}
                            style={CUSTOM_BADGE[group.color] || {}}
                        >
                            {group.label}
                        </span>
                        {group.rows.length} entr{group.rows.length !== 1 ? 'ies' : 'y'}
                    </td>
                </tr>

                
                {group.rows.map((trx, i) => {
                    serial++;
                    return (
                        <tr key={trx.transaction_id || `${group.key}-${i}`}
                            style={trx.is_return || Number(trx.payment_amount) < 0 ? { backgroundColor: '#fff5f5' } : {}}>
                            <td>{serial}</td>
                            <td><strong className="text-primary">{trx.uhid || 'N/A'}</strong></td>
                            <td>{trx.patient_name || 'N/A'}</td>
                            <td>
                                {trx.department === 'Procedure' ? (
                                    <span className="badge" style={{ fontSize: '9px', ...CUSTOM_BADGE.procedure }}>
                                        {trx.department}
                                    </span>
                                ) : (
                                    <span className={`badge ${getDeptBadgeClass(trx.department)}`} style={{ fontSize: '9px' }}>
                                        {trx.department}
                                    </span>
                                )}
                            </td>
                            <td>{formatDate(trx.payment_date)}</td>
                            <td>{formatTime(trx.payment_time)}</td>
                            <td>{getPaymentModeBadge(trx.payment_mode)}</td>
                            <td className={`text-end fw-bold ${Number(trx.payment_amount) < 0 ? 'text-danger' : 'text-success'}`}>
                                {Number(trx.payment_amount) < 0 ? '- ' : ''}₹{Math.abs(Number(trx.payment_amount || 0)).toFixed(2)}
                            </td>
                            <td>{trx.received_by_name || 'N/A'}</td>
                        </tr>
                    );
                })}

               
                <tr className="table-light fw-bold">
    <td colSpan="7" className="text-end">
        {group.label} → Cash {money(group.sub.cash)} | Card {money(group.sub.card)} | Online {money(group.sub.online)} — Subtotal:
    </td>
    <td className={`text-end ${group.sub.total < 0 ? 'text-danger' : 'text-primary'}`}>
        {money(group.sub.total)}
    </td>
    <td></td>
</tr>
            </React.Fragment>
        ));
    })()}
</tbody>
{filteredTransactions.length > 0 && (
   <tfoot>
   <tr>
       <td colSpan="7" className="text-end fw-bold" style={{ backgroundColor: '#405189', color: '#fff' }}>
           GRAND TOTAL → Cash {money(filteredTotals.cash)} | Card {money(filteredTotals.card)} | Online {money(filteredTotals.online)}
       </td>
       <td className="text-end fw-bold" style={{ backgroundColor: '#405189', color: '#fff' }}>
           {money(filteredTotals.total)}
       </td>
       <td style={{ backgroundColor: '#405189' }}></td>
   </tr>
</tfoot>
)}
                                    </table>  */} 




                                 {/* ===== NEW TABLE: one row per patient, mode-wise columns ===== */}
<table className="table table-sm table-bordered table-hover mb-0 align-top" style={{ fontSize: '11px' }}>
    <thead className="table-dark sticky-top">
        <tr>
            <th style={{ width: '40px' }}>#</th>
            <th>UHID</th>
            <th>Patient</th>
            <th>Dept</th>
            <th style={{ minWidth: '160px' }}>Cash</th>
            <th style={{ minWidth: '160px' }}>Online</th>
            <th style={{ minWidth: '160px' }}>Card</th>
            <th className="text-end">Total</th>
            <th className="text-end">Due</th>
        </tr>
    </thead>
    <tbody>
        {isLoading ? (
            <tr><td colSpan="9" className="text-center py-3"><div className="spinner-border spinner-border-sm"></div></td></tr>
        ) : filteredTransactions.length === 0 ? (
            <tr><td colSpan="9" className="text-center py-3 text-muted">
                {searchKey ? `No transactions found for "${searchKey}"` : 'No transactions'}
            </td></tr>
        ) : (() => {
            let serial = 0;
            return groupedTransactions.map(group => (
                <React.Fragment key={group.key}>
                    {/* group header */}
                                        {/* group header — click to collapse/expand */}
                                        <tr className="table-secondary" style={{ cursor: 'pointer' }}
                        onClick={() => toggleGroup(group.key)}>
                        <td colSpan="9" className="fw-bold">
                            <i className={`me-1 ${collapsedGroups[group.key] ? 'ri-arrow-right-s-line' : 'ri-arrow-down-s-line'}`}></i>
                            <span
                                className={`badge me-2 ${CUSTOM_BADGE[group.color] ? '' : `bg-${group.color} ${group.color === 'warning' ? 'text-dark' : ''}`}`}
                                style={CUSTOM_BADGE[group.color] || {}}
                            >
                                {group.label}
                            </span>
                            {group.patients.length} patient{group.patients.length !== 1 ? 's' : ''}
                            <span className="text-muted fw-normal ms-2">({group.rows.length} payments)</span>
                        </td>
                    </tr>

                    {/* one row per patient */}
                                       {/* ✅ PROCEDURE → sub-sections per patient type */}
                    {group.subGroups && !collapsedGroups[group.key] && group.subGroups.map(sg => (
                        <React.Fragment key={`sg-${sg.key}`}>

                            {/* sub-section header */}
                            <tr style={{ backgroundColor: '#f3f6fb' }}>
                                <td colSpan="9" className="fw-bold ps-4">
                                    <i className="ri-corner-down-right-line me-1 text-muted"></i>
                                    <span className="badge me-2" style={{ background: sg.color, fontSize: '9px' }}>
                                        {sg.label}
                                    </span>
                                    {sg.patients.length} patient{sg.patients.length !== 1 ? 's' : ''}
                                    <span className="text-muted fw-normal ms-2">({sg.rows.length} payments)</span>
                                </td>
                            </tr>

                            {/* patients in this sub-section */}
                            {sg.patients.map(p => {
                                serial++;
                                return (
                                    <tr key={`${sg.key}-${p.key}`}
                                        style={p.total < 0 ? { backgroundColor: '#fff5f5' } : {}}>
                                        <td>{serial}</td>
                                        <td><strong className="text-primary">{p.uhid || 'N/A'}</strong></td>
                                        <td>{p.patient_name || 'N/A'}</td>
                                        <td>
                                            <span className="badge" style={{ fontSize: '9px', background: sg.color, color: '#fff' }}>
                                                {sg.label}
                                            </span>
                                        </td>
                                        <td>{renderPayCell(p.cash, 'Cash')}</td>
                                        <td>{renderPayCell(p.online, 'Online')}</td>
                                        <td>{renderPayCell(p.card, 'Card')}</td>
                                        <td className={`text-end fw-bold ${p.total < 0 ? 'text-danger' : 'text-primary'}`}>
                                            {money(p.total)}
                                        </td>
                                        <td className={`text-end fw-bold ${p.due > 0 ? 'text-danger' : 'text-muted'}`}>
                                            {p.due === null ? '—' : money(p.due)}
                                        </td>
                                    </tr>
                                );
                            })}

                            {/* sub-section total */}
                            <tr className="fw-bold" style={{ backgroundColor: '#eef2f8' }}>
                                <td colSpan="4" className="text-end">
                                    <span className="badge me-2" style={{ background: sg.color, fontSize: '9px' }}>
                                        {sg.label}
                                    </span>
                                    Total:
                                </td>
                                <td>{money(sg.sub.cash)}</td>
                                <td>{money(sg.sub.online)}</td>
                                <td>{money(sg.sub.card)}</td>
                                <td className={`text-end ${sg.sub.total < 0 ? 'text-danger' : 'text-primary'}`}>
                                    {money(sg.sub.total)}
                                </td>
                                <td></td>
                            </tr>
                        </React.Fragment>
                    ))}

                    {/* one row per patient (all non-Procedure groups) */}
                    {!group.subGroups && !collapsedGroups[group.key] && group.patients.map(p => {
    serial++;

    const isLabItem = (it) => /lab|investigation/i.test(it.payment_type || '');
    const splitArr  = (arr) => ({
        bill: (arr || []).filter(it => !isLabItem(it)),
        lab:  (arr || []).filter(it =>  isLabItem(it)),
    });
    const sum = (arr) => arr.reduce((s, i) => s + i.amt, 0);

    const cash = splitArr(p.cash), online = splitArr(p.online), card = splitArr(p.card);
    const billTotal = sum(cash.bill) + sum(online.bill) + sum(card.bill);
    const labTotal  = sum(cash.lab)  + sum(online.lab)  + sum(card.lab);
    const hasBill = (cash.bill.length || online.bill.length || card.bill.length) > 0;
    const hasLab  = (cash.lab.length  || online.lab.length  || card.lab.length)  > 0;

    const deptBadge = (
        p.department === 'Procedure'
            ? <span className="badge" style={{ fontSize: '9px', ...CUSTOM_BADGE.procedure }}>{p.department}</span>
            : <span className={`badge ${getDeptBadgeClass(p.department)}`} style={{ fontSize: '9px' }}>{p.department}</span>
    );

    // ✅ IPD group with BOTH bill + investigation → 2 stacked rows (rowspan identity) + combined total
    if (group.key === 'ipd' && hasBill && hasLab) {
        return (
            <React.Fragment key={`${group.key}-${p.key}`}>
                <tr style={{ backgroundColor: p.total < 0 ? '#fff5f5' : '#eef3ff' }}>
                    <td rowSpan={3}>{serial}</td>
                    <td rowSpan={3}><strong className="text-primary">{p.uhid || 'N/A'}</strong></td>
                    <td rowSpan={3}>{p.patient_name || 'N/A'}</td>
                    <td><span className="badge bg-primary" style={{ fontSize: '9px' }}>IPD Bill</span></td>
                    <td>{renderPayCell(cash.bill, 'Cash')}</td>
                    <td>{renderPayCell(online.bill, 'Online')}</td>
                    <td>{renderPayCell(card.bill, 'Card')}</td>
                    <td className="text-end fw-bold text-primary">{money(billTotal)}</td>
                    <td rowSpan={3} className={`text-end fw-bold ${p.due > 0 ? 'text-danger' : 'text-muted'}`}>
                        {p.due === null ? '—' : money(p.due)}
                    </td>
                </tr>
                
                <tr style={{ backgroundColor: '#fff8e1', borderTop: '3px solid #fd7e14' }}>
                <td><span className="badge bg-warning text-dark" style={{ fontSize: '9px' }}>Investigation</span></td>
                    <td>{renderPayCell(cash.lab, 'Cash')}</td>
                    <td>{renderPayCell(online.lab, 'Online')}</td>
                    <td>{renderPayCell(card.lab, 'Card')}</td>
                    <td className="text-end fw-bold text-warning">{money(labTotal)}</td>
                </tr>
                <tr className="table-light" style={{ borderTop: '2px solid #405189' }}>
                    <td colSpan="4" className="text-end fw-bold">Combined (IPD + Investigation):</td>
                    <td className="text-end fw-bold text-primary">{money(billTotal + labTotal)}</td>
                </tr>
            </React.Fragment>
        );
    }

    // Default: single row (unchanged behaviour for all other cases)
    return (
        <tr key={`${group.key}-${p.key}`} style={p.total < 0 ? { backgroundColor: '#fff5f5' } : {}}>
            <td>{serial}</td>
            <td><strong className="text-primary">{p.uhid || 'N/A'}</strong></td>
            <td>{p.patient_name || 'N/A'}</td>
            <td>
                {deptBadge}
                {p.branch_name && (
                    <div className="text-muted mt-1" style={{ fontSize: '9px' }}>
                        <i className="ri-git-branch-line"></i> {p.branch_name}
                    </div>
                )}
            </td>
            <td>{renderPayCell(p.cash, 'Cash')}</td>
            <td>{renderPayCell(p.online, 'Online')}</td>
            <td>{renderPayCell(p.card, 'Card')}</td>
            <td className={`text-end fw-bold ${p.total < 0 ? 'text-danger' : 'text-primary'}`}>
                {money(p.total)}
            </td>
            <td className={`text-end fw-bold ${p.due > 0 ? 'text-danger' : 'text-muted'}`}>
                {p.due === null ? '—' : money(p.due)}
            </td>
        </tr>
    );
})}

                    {/* group subtotal */}
                    {!collapsedGroups[group.key] && (
                                               <tr className="table-light fw-bold"
                            style={group.subGroups ? { borderTop: '2px solid #405189' } : {}}>
                            <td colSpan="4" className="text-end">
                                {group.subGroups ? 'PROCEDURES TOTAL:' : `${group.label} Subtotal:`}
                            </td>
                            <td>{money(group.sub.cash)}</td>
                            <td>{money(group.sub.online)}</td>
                            <td>{money(group.sub.card)}</td>
                            <td className={`text-end ${group.sub.total < 0 ? 'text-danger' : 'text-primary'}`}>{money(group.sub.total)}</td>
                            <td className="text-end text-danger">{group.sub.due ? money(group.sub.due) : '—'}</td>
                        </tr>
                    )}

                    {/* ✅ OPD charge heads — consultation + registration, shown under the OPD subtotal */}
                    {group.key === 'opd' && !collapsedGroups[group.key] && opdFeeSummary.visits > 0 && (
                        <>
                            <tr style={{ backgroundColor: '#f0f7ff' }}>
                                <td colSpan="7" className="text-end fw-bold">
                                    <i className="ri-stethoscope-line me-1"></i>Doctor Consultation Charges
                                    <span className="text-muted fw-normal ms-2" style={{ fontSize: '10px' }}>
                                        ({opdFeeSummary.visits} visit{opdFeeSummary.visits !== 1 ? 's' : ''})
                                    </span>
                                </td>
                                <td className="text-end fw-bold">{money(opdFeeSummary.consultation)}</td>
                                <td></td>
                            </tr>

                            <tr style={{ backgroundColor: '#f0f7ff' }}>
                                <td colSpan="7" className="text-end fw-bold">
                                    <i className="ri-file-list-3-line me-1"></i>Registration Charges
                                </td>
                                <td className="text-end fw-bold">{money(opdFeeSummary.registration)}</td>
                                <td></td>
                            </tr>

                            <tr style={{ backgroundColor: '#e7f1ff', borderTop: '1px solid #adb5bd' }}>
                                <td colSpan="7" className="text-end fw-bold">
                                    Gross (Consultation + Registration):
                                </td>
                                <td className="text-end fw-bold">{money(opdFeeSummary.gross)}</td>
                                <td></td>
                            </tr>

                            {opdFeeSummary.discount > 0 && (
                                <tr style={{ backgroundColor: '#fff8e1' }}>
                                    <td colSpan="7" className="text-end fw-bold text-danger">
                                        Less: Discount
                                        {opdFeeSummary.pctVisits > 0 && (
                                            <span className="text-muted fw-normal ms-2" style={{ fontSize: '10px' }}>
                                                ({opdFeeSummary.pctVisits} by %)
                                            </span>
                                        )}
                                    </td>
                                    <td className="text-end fw-bold text-danger">- {money(opdFeeSummary.discount)}</td>
                                    <td></td>
                                </tr>
                            )}

                            <tr style={{ backgroundColor: '#e7f1ff', borderTop: '2px solid #405189' }}>
                                <td colSpan="7" className="text-end fw-bold">Net Payable (after discount)</td>
                                <td className="text-end fw-bold text-primary">{money(opdFeeSummary.net)}</td>
                                <td className="text-end fw-bold text-danger">
                                    {opdFeeSummary.net - opdFeeSummary.collected > 0
                                        ? money(opdFeeSummary.net - opdFeeSummary.collected)
                                        : '—'}
                                </td>
                            </tr>
                        </>
                    )}
                </React.Fragment>
            ));
        })()}
    </tbody>
    {filteredTransactions.length > 0 && (
        <tfoot>
            <tr className="fw-bold">
                <td colSpan="4" className="text-end" style={{ backgroundColor: '#405189', color: '#fff' }}>GRAND TOTAL:</td>
                <td style={{ backgroundColor: '#405189', color: '#fff' }}>{money(filteredTotals.cash)}</td>
                <td style={{ backgroundColor: '#405189', color: '#fff' }}>{money(filteredTotals.online)}</td>
                <td style={{ backgroundColor: '#405189', color: '#fff' }}>{money(filteredTotals.card)}</td>
                <td className="text-end" style={{ backgroundColor: '#405189', color: '#fff' }}>{money(filteredTotals.total)}</td>
                <td className="text-end" style={{ backgroundColor: '#405189', color: '#fff' }}>
    {money(Object.values(Object.assign({}, ...groupedTransactions.map(g => g.dueMap))).reduce((s, v) => s + v, 0))}
</td>
            </tr>
        </tfoot>
    )}
</table>   


                                </div>
                            </div>
                        </div>

                       {/* Individual refund cards */}
{filteredTotals.refunds > 0 && (
    <div className="row mt-3 mb-3 g-2">
        {[
            ['pharmacy_return', 'Pharmacy Returns'],
            ['ipd_return', 'IPD Refunds'],
            ['lab_refund', 'Lab Refunds'],
            ['opd_refund', 'OPD Refunds'],
        ].filter(([k]) => filteredRefunds[k] > 0).map(([k, label]) => (
            <div className="col-md-2 col-6" key={k}>
                <div className="card border-danger h-100">
                    <div className="card-body text-center py-2">
                        <small className="text-muted">{label}</small>
                        <h6 className="text-danger mb-0">- ₹{filteredRefunds[k].toFixed(2)}</h6>
                    </div>
                </div>
            </div>
        ))}
    </div>
)}

{/* Gross − Refunds = Net Collection − Expenses = In Hand */}
{filteredTransactions.length > 0 && (
    <div className="row mb-3 g-2">
        <div className="col-md col-6">
            <div className="card bg-primary text-white h-100">
                <div className="card-body text-center py-2">
                    <small className="text-white-50">Gross Collection</small>
                    <h5 className="text-white mb-0">₹{filteredTotals.gross.toFixed(2)}</h5>
                </div>
            </div>
        </div>
        <div className="col-md col-6">
            <div className="card bg-warning h-100">
                <div className="card-body text-center py-2">
                    <small className="text-dark">Total Refunds</small>
                    <h5 className="text-dark mb-0">- ₹{filteredTotals.refunds.toFixed(2)}</h5>
                </div>
            </div>
        </div>
        <div className="col-md col-6">
            <div className="card bg-success text-white h-100">
                <div className="card-body text-center py-2">
                    <small className="text-white-50">Net Collection</small>
                    <h5 className="text-white mb-0">{money(filteredTotals.total)}</h5>
                </div>
            </div>
        </div>
        {!branchFilterActive && (
            <div className="col-md col-6">
                <div className="card bg-danger text-white h-100">
                    <div className="card-body text-center py-2">
                        <small className="text-white-50">Total Expenses</small>
                        <h5 className="text-white mb-0">- ₹{Math.abs(Number(expensesTotal)).toFixed(2)}</h5>
                    </div>
                </div>
            </div>
        )}
        {!branchFilterActive && (
            <div className="col-md col-6">
                <div className="card bg-dark text-white h-100">
                    <div className="card-body text-center py-2">
                        <small className="text-white-50">Net Amount (In Hand)</small>
                        <h5 className="text-white mb-0">{money(filteredTotals.total - Math.abs(Number(expensesTotal)))}</h5>
                    </div>
                </div>
            </div>
        )}
    </div>
)}

                   
                    </>
                )}

                {/* ============================================ */}
                {/* TAB 2: BALANCE SHEET (imported component)     */}
                {/* Independent — does NOT inherit Daybook dates  */}
                {/* ============================================ */}
                {activeTab === 'balance' && (
                    <BalanceSheet
                        onCountChange={setBalanceCount}
                    />
                )}

                {/* ============================================ */}
                {/* TAB 3: IPD NET COLLECTION                     */}
                {/* ============================================ */}
                {activeTab === 'ipd_net' && (
                    <IpdNetCollection
                        onCountChange={setIpdNetCount}
                    />
                )}
            </div>
        </div>
    );
}

export default Daybook;